/**
 * Button — Bra Game R1 primitive.
 *
 * variants: primary (pink gradient), gold (gold gradient), secondary (elevated),
 *           ghost (transparent+border), danger (red).
 * sizes:    sm, md, lg, xl.
 */
import { forwardRef } from "react";

const V = {
  primary: "text-white bg-brand-gradient shadow-glow-pink hover:brightness-110",
  gold: "text-[#0B0E1E] bg-gold-gradient shadow-glow-gold hover:brightness-110 font-semibold",
  secondary: "text-ink bg-elevated hover:bg-highest border border-line",
  ghost: "text-ink bg-transparent border border-line hover:border-pink hover:text-pink",
  danger: "text-white bg-[color:var(--danger)] hover:brightness-110",
  link: "text-pink hover:underline underline-offset-4 p-0 shadow-none",
};
const S = {
  sm: "px-3 py-1.5 text-xs",
  md: "px-4 py-2 text-sm",
  lg: "px-6 py-3 text-sm",
  xl: "px-8 py-4 text-base",
};

const Button = forwardRef(function Button(
  { variant = "primary", size = "md", loading = false, disabled, className = "", children, ...rest },
  ref
) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-lg font-medium " +
    "transition-all duration-150 active:scale-[0.98] " +
    "disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:brightness-100 disabled:hover:scale-100 " +
    "hover:scale-[1.02] whitespace-nowrap";
  return (
    <button
      ref={ref}
      disabled={disabled || loading}
      className={`${base} ${V[variant] || V.primary} ${S[size] || S.md} ${className}`}
      {...rest}
    >
      {loading && <Spinner />}
      {children}
    </button>
  );
});

function Spinner() {
  return (
    <span className="inline-block h-3 w-3 rounded-full border-2 border-white/40 border-t-white animate-spin" />
  );
}

export default Button;
